import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Otkupne_cijene, ApiClientService } from '../../../../services/api-client.service';

@Component({
  selector: 'app-create-otkupne-cijene',
  templateUrl: './create-otkupne-cijene.component.html',
  styleUrls: ['./create-otkupne-cijene.component.scss']
})
export class CreateOtkupneCijeneComponent {
  @Input() set visible(value: boolean) {
    this.isVisible = value;
    if (value) {
      this.initializeForm();
    }
  }

  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() otkupneCijeneCreated = new EventEmitter<Otkupne_cijene>();

  isVisible = false;
  loading = false;
  otkupneCijeneForm!: FormGroup;
  maxDate = new Date();

  datumEditorOptions: any = {
    placeholder: 'Odaberite datum...',
    type: 'date',
    max: this.maxDate,
    displayFormat: "dd.MM.yyyy"
  };

  tekstEditorOptions: any = {
    placeholder: 'Unesite tekst otkupnih cijena...',
    autoResizeEnabled: true,
    height: 100
  };

  constructor(
    private fb: FormBuilder, 
    private apiClient: ApiClientService
  ) {}

  onPopupShown() {
    this.initializeForm();
  }

  initializeForm() {
    this.otkupneCijeneForm = this.fb.group({
      datum: [new Date().toISOString().split('T')[0], Validators.required],
      tekst: ['', Validators.required]
    });
  }

  onFieldDataChanged(e: any) {
    if (e.dataField && e.value !== undefined) {
      this.otkupneCijeneForm.patchValue({
        [e.dataField]: e.value
      });
    }
  }

  onPopupHiding() {
    this.isVisible = false;
    this.visibleChange.emit(false);
  }

  onCancel() {
    this.isVisible = false;
    this.visibleChange.emit(false);
    this.otkupneCijeneForm.reset();
  }

  async onSubmit() {
    if (this.otkupneCijeneForm.valid) {
      this.loading = true;

      try {
        const createdOtkupneCijene = await this.apiClient.otkupneCijenePOST(this.otkupneCijeneForm.value);

        this.otkupneCijeneCreated.emit(createdOtkupneCijene);
        this.isVisible = false;
        this.visibleChange.emit(false);
        this.otkupneCijeneForm.reset();

      } catch (error) {
        console.error('Error creating otkupne cijene:', error);
      } finally {
        this.loading = false;
      }
    } else {
      this.markFormGroupTouched(this.otkupneCijeneForm);
    }
  }

  private markFormGroupTouched(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(key => {
      const control = formGroup.get(key);
      if (control instanceof FormGroup) {
        this.markFormGroupTouched(control);
      } else {
        control?.markAsTouched();
      }
    });
  }
}